import { Box, Button, Modal, Typography } from "@mui/material";
import React, { createContext, useContext, useEffect, useState } from "react";
import { useLocation } from "react-router-dom";

// creating the context
const WhileQuizNavigationCheckContext = createContext();

// creating a provider function
export function WhileQuizNavigationCheck({ children }) {
    const [isQuizTest, setIsQuizTest] = useState(false);
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [yesButtonclick, setYesButtonclick] = useState(false);
    const [noButtonclick, setNoButtonclick] = useState(false);

    const location = useLocation();

    // Taking path name from the `url`
    const pathName = location.pathname.split("/");

    const pathNameEnd = pathName[pathName.length - 1];

    // const handleClose = () => {
    //     setIsModalOpen(false);
    //     console.log("handleClose", isModalOpen);
    // }

    // const handleOpen = () => {
    //     setIsModalOpen(true);
    //     console.log("handleOpen", isModalOpen);
    // }

    useEffect(() => {
        try {
            if (pathNameEnd === "QuizContent") {
                setIsQuizTest(true);
            } else {
                setIsQuizTest(false);
            }

            console.log("isQuizTest", isQuizTest);
        } catch (e) {
            console.log(e);
        }
    }, [pathName, pathNameEnd]);

    return (
        <WhileQuizNavigationCheckContext.Provider
            value={{isQuizTest,isModalOpen,setIsModalOpen, yesButtonclick, noButtonclick}}
        >
            <Modal
                open={isModalOpen}
            >
                <Box
                    sx={{
                        position: "absolute",
                        top: "50%",
                        left: "50%",
                        transform: "translate(-50%, -50%)",
                        width: 400,
                        bgcolor: "background.paper",
                        boxShadow: 24,
                        p: 4,
                        borderRadius: "5px"
                    }}
                >
                    <Typography
                        id="modal-modal-description"
                        variant="h3"
                        sx={{ mb: 2}}
                    >
                        Are you sure, you want to exit?
                    </Typography>
                    <Box sx={{
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                        gap: 2
                    }}>
                        <Button
                            variant="contained"
                            color="secondary"
                            onClick={() => {
                                setYesButtonclick(true);
                                setIsModalOpen(false);
                            }}
                            sx={{
                                width: "100%",
                            }}
                        >
                            Yes
                        </Button>
                        <Button
                            variant="outlined"
                            color="secondary"
                            onClick={() => {
                                setNoButtonclick(true);
                                setIsModalOpen(false);
                            }}
                            sx={{
                                width: "100%",
                            }}
                        >
                            No
                        </Button>
                    </Box>
                </Box>
            </Modal>
            {children}
        </WhileQuizNavigationCheckContext.Provider>
    );
}

export function useWhileQuizNavigationCheck() {
    const context = useContext(WhileQuizNavigationCheckContext);

    if (!context) {
        throw new Error(
            "useParentInfoCheck must be used within a ParentInfoCheckContext Provider"
        );
    }

    return context;
}
